import React from "react";
import { makeWsrvURL, EWsrvTransform } from "../../lib/Media/util";
import styled from "styled-components";

export interface sizesAndAspect {
  media?: string;
  /*
   * The part between the parenthesis in a media query.
   * Omit for un-restricted rule.
   */
  width?: number;
  /*
   * Width of the area the image will fill in pixles.
   * If full width, this will likely be the pixel width of the next largest media query
   */
  aspect?: EWsrvTransform;
  /*
   * Aspect ratio transformation based on EWsrvTransform
   * Defaults to EWsrvTransform.limit
   */
}

const defaultResponsive: sizesAndAspect[] = [
  {
    aspect: EWsrvTransform.bgcrop
  },
  {
    media: "min-width: 420px",
    aspect: EWsrvTransform.bgcrop
  },
  {
    media: "min-width: 640px",
    width: 768,
  },
  {
    media: "min-width: 768px",
    width: 1024,
  },
  {
    media: "min-width: 1024px",
    width: 1280,
  },
  {
    media: "min-width: 1280px",
    width: 1536,
  },
];

export interface IBackgoundImageProps {
  children?: React.ReactNode;
  /*
   * Source URL for in highest quality version of the image.
   */
  src: string;
  /*
   * Similar to the 'sizes' spec for img tags.
   * Object syntax. Width in pixes. Inlcudes aspect ratio.
   */
  sizesAndAspect?: sizesAndAspect[];
  overlayGradient?: string;
  className?: string;
  style?: React.CSSProperties;
  htmlIdAttribute?: string;
}

const BgDiv = styled.div<{ styleString: string }>`
background-size: cover;
background-position: center;
${p => p.styleString}
`;

export const BackgroundImage: React.FC<IBackgoundImageProps> = ({
  children,
  src,
  sizesAndAspect = defaultResponsive,
  className,
  overlayGradient,
  style,
  htmlIdAttribute,
}) => {
  const styleString = sizesAndAspect.map((size, index) => {
    const aspect = size.aspect ? size.aspect : EWsrvTransform.limit;
    let cssString = `background-image: ${overlayGradient ? overlayGradient : ''} url("${makeWsrvURL({
      originURL: src,
      preset: aspect,
      width: size.width,
    })}");`;
    cssString = size.media ? `@media(${size.media}){${cssString}}` : cssString;
    return cssString;
  }).join(``);

  return (
    <BgDiv id={htmlIdAttribute} className={className} style={style} styleString={styleString}>
      {children}
    </BgDiv>
  );
};

export default BackgroundImage;
